import React from 'react'
import CollectionMainPage from "../page/CollectionMainPage"

function GiftBoxMainPage({categoryType}) {
  return (
    <div>
    <CollectionMainPage categoryType={categoryType}/>
    </div>
  )
}

export default GiftBoxMainPage